import { gql } from "@apollo/client";

export const GET_BUSINESS_CUSTOMER_COUNT = gql`
  {
    businessCustomersCount
  }
`;